module.exports = __webpack_public_path__ + "img/cloud2.794b62cd.png";